module.exports = __webpack_public_path__ + "img/1602347278.1ad8877b.png";